// ─── App Version ────────────────────────────────────────────────────────────
// UPDATE THIS every release. Must match the version pushed to the Play Store
// and set via the admin panel /appversions endpoint.
export const APP_VERSION = '1.0.0';

// ─── Platform Detection ──────────────────────────────────────────────────────
export function getAppPlatform() {
  try {
    if (
      typeof window !== 'undefined' &&
      window.Capacitor?.isNativePlatform?.()
    ) {
      return window.Capacitor.getPlatform?.() || 'android'; // 'android' | 'ios'
    }
  } catch {/* ignore */}
  return 'web';
}

// ─── Semver Comparison ───────────────────────────────────────────────────────
// Returns: -1 if a < b  |  0 if equal  |  1 if a > b
export function compareVersions(a, b) {
  const pa = String(a || '0').split('.').map(Number);
  const pb = String(b || '0').split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    const na = pa[i] || 0;
    const nb = pb[i] || 0;
    if (na < nb) return -1;
    if (na > nb) return 1;
  }
  return 0;
}
